<template>
  <div class="view">
    <div class="title">
      <i class="goback el-icon-arrow-left" @click="goback"></i>动态管理
    </div>
    <div class="content contentBody">
      <div class="content-tab-box">
        <span :class="tabCurrent==1?'content-tab-box-active':''" @click="tabCurrentFn(1)">发布文章</span>
        <span :class="tabCurrent==2?'content-tab-box-active':''" @click="tabCurrentFn(2)">发布图文</span>
      </div>
      <div v-if="!loading">
        <publishArticle v-if="tabCurrent==1" :optionList="optionList" :formData.sync="formData" @saveFrom="saveFrom"
                        :pageType="pageType" :programaType="programaType"></publishArticle>
        <publishPicture v-if="tabCurrent==2" :optionList="optionList" :formData.sync="formTextData"
                        @saveFrom="saveFrom"
                        :pageType="pageType" :programaType="programaType"></publishPicture>
      </div>
    </div>
  </div>
</template>
<script>
  import publishArticle from "./publishArticle.vue";
  import publishPicture from "./publishPicture.vue";
  import api from '@/api.js'
  export default {
    name: "momentsEdit",
    components: {
      publishArticle,
      publishPicture,
    },
    data() {
      return {
        tabCurrent: 1,
        optionList: null,
        loading: false,
        dynamic_type: 1,
        tabStatus: false,
        formData: {
          dynamic_type: 0, // 	整型 	必填 	- 	- 	动态类型(0文章、1图文)
          title: '', // 	varchar 	非必填 	- 	- 	文章标题(动态类型为文章时必填)
          biref: '', // 	varchar 	非必填 	- 	- 	文章简介
          pro_id: '', //	整型 	非必填 	- 	- 	所属栏目
          content: '', // 	varchar 	非必填 	- 	- 	文章内容(动态类型为文章时必填)
          pic: '', //	varchar 	非必填 	- 	- 	图片(当动态类型为图文时可为多张，多张图片用逗号分隔)
          form_id: '', // 	整型 	非必填 	- 	- 	表单id
          button_name: '', // 	varchar 	非必填 	- 	- 	按钮名称
          is_sub: 0, // 	varchar 	必填 	- 	- 	是否发布(0仅保存、1已发布)
          goods_arr: [],
          form_arr: []
        },
        formTextData: {
          dynamic_type: 1, // 	整型 	必填 	- 	- 	动态类型(0文章、1图文)
          title: '', // 	varchar 	非必填 	- 	- 	文章标题(动态类型为文章时必填)
          biref: '', // 	varchar 	非必填 	- 	- 	文章简介
          pro_id: '', //	整型 	非必填 	- 	- 	所属栏目
          content: '', // 	varchar 	非必填 	- 	- 	文章内容(动态类型为文章时必填)
          pic: [], //	varchar 	非必填 	- 	- 	图片(当动态类型为图文时可为多张，多张图片用逗号分隔)
          form_id: '', // 	整型 	非必填 	- 	- 	表单id
          button_name: '', // 	varchar 	非必填 	- 	- 	按钮名称
          is_sub: 0, // 	varchar 	必填 	- 	- 	是否发布(0仅保存、1已发布)
          goods_arr: [],
          form_arr: []
        },
        pageInfo: this.$route.query,
        pageType: this.$route.query.pageType,
        programaType: this.$route.query.programaType
      };
    },
    created() {
      this.InitFn()
    },
    methods: {
      InitFn() {
        // 所属栏目
        // is_add:1
        let data_ = {}
        if(this.pageType === 'add'){
          data_ = {is_add:1}
        }
        this.axios
            .post(api.programa_index, data_)
            .then(response => {
              if (response.data.code == 0) {
                response.data.list.unshift({name: '全部', id: 0})
                this.formData.pro_id = 0
                this.optionList = response.data.list
                if (this.pageInfo.id) {
                  this.loading = true
                  // this.dynamic_type = this.pageInfo.dynamic_type
                  this.tabCurrent = this.pageInfo.dynamic_type
                  // this.pageInfo.dynamic_type 1 文章 2 图文
                  this.editMomentsEdit()
                } else {
                  this.tabStatus = true;
                }
              } else {

              }
            })
            .catch(response => {
            });
      },
      editMomentsEdit() {
        // console.log('获取数据详情===>:', this.pageInfo,this.dynamic_type, this.pageInfo.id)
        this.axios
            .post(api.diary_detail, {diary_id: this.pageInfo.id})
            .then(response => {
              if (response.data.code == 0) {
                if (Number(this.tabCurrent)  ===1) {
                  // 发布文章
                  for (let i in this.formData) {
                    if (i === 'pic') {
                      this.formData[i] = response.data.info[i].split(',')
                    } else {
                      this.formData[i] = response.data.info[i]
                    }
                  }
                } else {
                  for (let i in this.formTextData) {
                    this.formTextData[i] = response.data.info[i]
                  }
                }
                // <span v-if="scope.row.type==0">支持企业动态和个人动态</span>
                //         <span v-if="scope.row.type==1">仅支持企业动态</span>
                //         <span v-if="scope.row.type==2">仅支持个人动态</span>
                //console.log('optionlist:',this.optionList,response.data.info.type)
                let optionlist = []
                for(let i in this.optionList){
                  //console.log('i:', i)
                  if(this.optionList[i].id!==0){
                    // 个人
                    if(response.data.info.type===0){
                      if(this.optionList[i].type===0||this.optionList[i].type===2){
                        optionlist.push(this.optionList[i])
                      }
                    }
                    // 企业
                    if(response.data.info.type===1){
                      if(this.optionList[i].type===0||this.optionList[i].type===1){
                        optionlist.push(this.optionList[i])
                      }
                    }
                  }else{
                    optionlist.push(this.optionList[i])
                  }
                }
                this.optionList = optionlist
                this.tabStatus = true;
                this.loading = false;
              } else {
              }
            })
            .catch(response => {
            });
      },
      handleClick(tab, event) {
      },
      goback() {
        this.$router.go(-1);
      },
      saveFrom(form) {
        // dynamic_type: 0, // 	整型 	必填 	- 	- 	动态类型(0文章、1图文)

        let data_ = this.formData; // article imgtxt
        if (Number(this.tabCurrent) === 2) {
          data_ = form;
        }
        if (!data_.title && Number(this.tabCurrent) === 1) {
          this.$message({
            message: '请填写文章标题',
            type: 'warning'
          });
          return
        }
        // if (!data_.biref && this.tabCurrent === 1) {
        //   this.$message({
        //     message: '请填写文章简介',
        //     type: 'warning'
        //   });
        //   return
        // }
        if (!data_.content) {
          this.$message({
            message: '请填写文章内容',
            type: 'warning'
          });
          return
        }
        if (!data_.pic) {
          this.$message({
            message: '请上传封面图片',
            type: 'warning'
          });
          return
        }
        this.loading = true
        let url_ = api.diary_add
        if (this.pageType === 'edit') {
          url_ = api.diary_edit
          data_.diary_id = this.pageInfo.id
        }
        this.axios
            .post(url_, data_)
            .then(response => {
              if (response.data.code == 0) {
                this.$router.go(-1);
              } else {
                this.$message.error('保存失败');
                this.loading = false
              }
            })
            .catch(response => {
            });
      },
      tabCurrentFn(index) {
        this.tabCurrent = index
      }
    }
  };
</script>
